import { PailPlusIcon } from './PailPlusIcon';

/**
 * author: Michael Irigoyen
 * id ED64CE31-8F78-4383-A3BF-2AFBE5485E38
 * name pail-plus
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pail-plus.svg
 * tags
 */
export const BucketPlusIcon = PailPlusIcon;
export default BucketPlusIcon